<template>
  <div class="forum-next-section-index">
    <router-link class="forum-next-section-index__values" :to="home({ view: 'values' })">
      <div><strong>Valores</strong><p>Conversaciones sobre los activos del mercado</p></div><span aria-hidden="true">›</span>
    </router-link>
    <ul v-if="rows.length" aria-label="Secciones del foro">
      <li v-for="row in rows" :key="row.section.id" :class="{ 'is-group': row.section.isContainer, 'is-child': row.depth > 0 }" :style="{ '--section-depth': Math.min(row.depth, 3) }">
        <div class="forum-next-section-index__description">
          <p v-if="row.depth > 1" class="forum-next-section-index__parent">{{ row.parentTitle }}</p>
          <h3><router-link v-if="!row.section.isContainer || row.section.topicCount" :to="sectionLink(row.section)">{{ row.section.title }}</router-link><span v-else>{{ row.section.title }}</span></h3>
          <p v-if="row.section.description">{{ row.section.description }}</p>
          <span class="forum-next-section-index__count" v-if="row.section.isContainer">{{ number(row.childCount) }} {{ row.childCount === 1 ? 'sección' : 'secciones' }}</span>
          <span class="forum-next-section-index__count" v-else>{{ number(row.section.topicCount) }} {{ row.section.topicCount === 1 ? 'conversación' : 'conversaciones' }}</span>
        </div>
        <div v-if="row.section.latest" class="forum-next-section-index__latest">
          <span>Última actividad · <ForumDate :value="row.section.latest.activityAt" /></span>
          <router-link :to="threadLink(row.section.latest.threadId, { position: 'last' })">{{ row.section.latest.title }}</router-link>
        </div>
        <p v-else-if="!row.section.isContainer" class="forum-next-section-index__empty">{{ row.section.topicCount ? 'No hay actividad disponible en este momento.' : 'Sin conversaciones todavía.' }}</p>
      </li>
    </ul>
    <p v-else class="forum-next-status">No hay secciones disponibles para tu cuenta.</p>
  </div>
</template>
<script>
import ForumDate from './ForumDate.vue';
import { sectionRows } from '../models/forumSections';
import { forumHome, sectionLink, threadLink } from '../models/forumNavigation';
export default {
  name: 'ForumSections', components: { ForumDate }, props: { sections: { type: Array, required: true } },
  computed: { rows() { return sectionRows(this.sections); } },
  methods: { home: forumHome, sectionLink, threadLink, number(value) { return new Intl.NumberFormat('es-ES').format(value); } }
};
</script>
<style lang="scss">
.forum-next-section-index {
  &__values { display: flex; align-items: center; justify-content: space-between; gap: 16px; padding: 18px 16px; margin: 0 0 20px; border: 1px solid var(--modern-border); border-radius: 10px; color: var(--forum-next-link); }
  &__values strong { font-size: 17px; } &__values p { margin: 4px 0 0; font-size: 14px; color: var(--modern-muted); }
  ul { list-style: none; margin: 0; padding: 0; }
  li { display: grid; gap: 12px; padding: 20px 0; border-bottom: 1px solid var(--modern-border); min-width: 0; }
  li.is-child { padding-left: calc(12px * var(--section-depth)); }
  li.is-group { padding: 14px 12px; margin-top: 20px; background: var(--modern-bg); border-radius: 8px; border-bottom: 0; }
  li.is-group:first-child { margin-top: 0; }
  h3 { font-size: 16px; margin: 0; line-height: 1.4; overflow-wrap: anywhere; }
  h3 a { display: inline-flex; align-items: center; min-height: 44px; color: var(--modern-text); }
  &__description > p { color: var(--modern-muted); margin: 3px 0 8px; font-size: 14px; line-height: 1.5; overflow-wrap: anywhere; }
  &__description > .forum-next-section-index__parent { font-size: 12px; }
  &__count, &__empty, &__latest > span { color: var(--modern-muted); font-size: 13px; }
  &__empty { margin: 0; }
  &__latest { display: grid; gap: 3px; min-width: 0; }
  &__latest a { display: inline-flex; align-items: center; min-height: 44px; line-height: 1.45; font-size: 14px; overflow-wrap: anywhere; }
  @media (min-width: 768px) {
    li:not(.is-group) { grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr); gap: 24px; align-items: center; }
  }
}
</style>
